module.exports = __webpack_public_path__ + "static/media/quote-left-solid.efb5734b.svg";